import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/common/Layout';
import DashboardLayout from './components/dashboard/DashboardLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Auth
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ResetPassword from './components/auth/ResetPassword';
import ForgotPassword from './components/auth/ForgotPassword';
import CreatorProfile from './components/explore/CreatorProfile';

// Pages (Public - use Layout)
import Home from './pages/Home';
import BetCodes from './pages/BetCodes';
import BetCodeDetail from './pages/BetCodeDetail';
import Competitions from './pages/Competitions';
import CompetitionDetail from './pages/CompetitionDetail';
import H2H from './pages/H2H';
import H2HDetail from './pages/H2HDetail';
import Rollover from './pages/Rollover';
import RolloverDetail from './pages/RolloverDetail';
import Leaderboard from './pages/Leaderboard';
import Explore from './pages/Explore';
import Search from './pages/Search';

// Pages (Protected - use DashboardLayout)
import Dashboard from './pages/Dashboard';
import Subscription from './pages/Subscription';
import CreatorDashboard from './pages/CreatorDashboard';
import ReferralDashboard from './pages/ReferralDashboard';
import CreateBetCode from './pages/CreateBetCode';
import CreateCompetition from './pages/CreateCompetition';
import CreateH2H from './pages/CreateH2H';
import CreateRollover from './pages/CreateRollover';
import Wallet from './pages/Wallet';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';

// Admin
import AdminDashboard from './pages/admin/AdminDashboard';
// Add to imports
import CryptoDeposit from './pages/CryptoDeposit';
import AdminCryptoDeposits from './pages/admin/AdminCryptoDeposits';


import './App.css';

function App() {
  return (
    <Routes>
      {/* Public Routes - Use Layout */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} /> 
      </Route>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />

      {/* Protected Routes - Use DashboardLayout */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="creator/dashboard" element={<CreatorDashboard />} />
          <Route path="referral" element={<ReferralDashboard />} />
          <Route path="bet-codes/create" element={<CreateBetCode />} />
          <Route path="competitions/create" element={<CreateCompetition />} />
          <Route path="h2h/create" element={<CreateH2H />} />
          <Route path="rollover/create" element={<CreateRollover />} />
          <Route path="wallet" element={<Wallet />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="admin" element={<AdminDashboard />} />
          <Route path="admin/crypto/deposits" element={<AdminCryptoDeposits />} />
          
        
        <Route path="bet-codes" element={<BetCodes />} />
        <Route path="bet-codes/:id" element={<BetCodeDetail />} />
        <Route path="competitions" element={<Competitions />} />
        <Route path="competitions/:id" element={<CompetitionDetail />} />
        <Route path="h2h" element={<H2H />} />
        <Route path="h2h/:id" element={<H2HDetail />} />
        <Route path="rollover" element={<Rollover />} />
        <Route path="rollover/:id" element={<RolloverDetail />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="explore" element={<Explore />} />
         <Route path="explore/creator/:id" element={<CreatorProfile />} />
        <Route path="search" element={<Search />} />
         
        <Route path="crypto/deposit" element={<CryptoDeposit />} />

 


        </Route>
      </Route>
    </Routes>
  );
}

export default App;